(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





// src props이 nullish 값에 에러로 반응해서 대응할 수 있도록 처리
var Image = function(props) {
    var wrapperRef = props.wrapperRef, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "wrapperRef"
    ]);
    return props.src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        onLoad: function(e) {
            e.currentTarget.style.display = "block";
        },
        onError: function(e) {
            var ref;
            // 상위 엘리먼트가 전달된 경우 상위 엘리먼트를 hidden 시킴
            if (wrapperRef === null || wrapperRef === void 0 ? void 0 : (ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.style) {
                wrapperRef.current.style.display = "none";
            } else {
                e.currentTarget.style.display = "none";
            }
        },
        // 기존 설정값. 아이콘이미지에서 많이 사용하기 때문에 50 x 50 으로 주고 사용하는 컴포넌트측에서 랩퍼 엘리먼트로 가로세로 지정하여 사용
        layout: "responsive",
        width: 50,
        height: 50
    }, imageProps)) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 94161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EbestWebViewLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/pages/ebest/ebest-components/ebest-webview-layout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-ebest-grayscale-gray50);\n\n  /* 본문 기본 스타일 */\n  font-size: var(--font-size-13);\n  font-weight: 400;\n  color: #444444;\n  line-height: var(--spacing-legacy-18);\n  letter-spacing: -0.5px;\n\n  /* 제목 스타일 */\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  .mainTitle,\n  .topic-title {\n    font-size: var(--font-size-16);\n    font-weight: 700;\n    color: #000000;\n    line-height: var(--spacing-legacy-24);\n    letter-spacing: -0.5px;\n  }\n\n  > main {\n    margin: auto;\n    width: 40rem;\n    min-height: 100vh;\n    background-color: var(--color-ebest-primary-white);\n\n    @media (max-width: 767px) {\n      width: 100%;\n\n      min-height: -moz-available;\n      min-height: -webkit-fill-available;\n      min-height: fill-available;\n    }\n  }\n\n  // 텍스트 드래그 금지\n  -ms-user-select: none;\n  -moz-user-select: -moz-none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledEbestWebViewLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ced45422-0"
})(_templateObject());
/* harmony default export */ var styled = (StyledEbestWebViewLayout);

;// CONCATENATED MODULE: ./src/components/pages/ebest/ebest-components/ebest-webview-layout/index.tsx



function EbestWebViewLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            children: children
        })
    });
};


/***/ }),

/***/ 70312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ebest_dividend_investing_guide; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/pages/ebest/ebest-dividend-investing-guide/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: var(--spacing-legacy-32) var(--spacing-legacy-20) calc(var(--spacing-legacy-50) * 2)\n    var(--spacing-legacy-20);\n\n  pre {\n    white-space: pre-wrap;\n    color: var(--color-ebest-grayscale-gray900);\n  }\n\n  .mainTitle {\n    margin-bottom: var(--spacing-legacy-24);\n\n    font-weight: 700;\n    font-size: var(--font-size-16);\n    color: #000000;\n    line-height: var(--spacing-legacy-24);\n    letter-spacing: -0.5px;\n  }\n\n  .introduction {\n    font-weight: 400;\n    font-size: var(--font-size-13);\n    color: #444444;\n    line-height: var(--spacing-legacy-18);\n    letter-spacing: -0.5px;\n  }\n\n  .company-images {\n    margin: var(--spacing-legacy-24) 0;\n  }\n\n  .topic-title {\n    font-weight: 700;\n    font-size: var(--font-size-16);\n    color: #000000;\n    line-height: var(--spacing-legacy-24);\n    letter-spacing: -0.5px;\n\n    margin-top: var(--spacing-legacy-80);\n    margin-bottom: var(--spacing-legacy-16);\n  }\n\n  .topic-description {\n    font-weight: 400;\n    font-size: var(--font-size-13);\n    color: #444444;\n    line-height: var(--spacing-legacy-18);\n    letter-spacing: -0.5px;\n  }\n\n  .table-image {\n    margin: var(--spacing-legacy-24) 0;\n  }\n\n  .warning {\n    margin-top: var(--spacing-legacy-16);\n\n    font-weight: 400;\n    font-size: var(--font-size-13);\n    line-height: var(--spacing-legacy-18);\n    letter-spacing: -0.5px;\n\n    color: var(--color-ebest-grayscale-gray500);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledEbestDividendInvestingGuide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-892d8adf-0"
})(_templateObject());
/* harmony default export */ var styled = (StyledEbestDividendInvestingGuide);

// EXTERNAL MODULE: ./src/components/common/image/index.tsx
var common_image = __webpack_require__(91935);
;// CONCATENATED MODULE: ./src/components/pages/ebest/ebest-dividend-investing-guide/index.tsx




var strings = {
    mainTitle: "미국 주식으로\n매달 월급을 받을 수 있다고요?",
    introductionFirst: "미국 주식의 매력으로는 전 세계 최대 시장, 원하는 유형의 모든 투자처가 있는 2,600여 개의 ETF, 그리고 배당이 있습니다.\n\n국내에서는 보통 1년에 1번, 4월에 배당금을 지급하는 기업이 대부분인데 반하여 미국은 대부분의 기업이 분기 배당을 하고 있으며 월 배당 지급 종목도 상당수 있습니다.\n많은 미국의 분기 배당 실시 기업은 1,4,7,10월 2,5,8,11월 이런 식으로 각기 다른 시기별로 배당금을 지급하고 있습니다.\n\n각 시기별로 배당금을 지급하는 대표적인 종목은 뭐가 있을까요?\n",
    introductionSecond: "이처럼 서로 다른 배당금을 지급하는 종목을 조합해서 포트폴리오를 구성하면 매월 배당금을 받을 수 있습니다.\n예를 들어 머크, 애플, 마이크로소프트를 매수하면 매월 배당금을 받을 수 있습니다.\n",
    topicTitleFirst: "다양한 배당투자 방법",
    firstTopicDescription: "이렇게 어떤 종목, ETF를 담는지에 따라 다양한 배당투자가 가능합니다. 예를 들어 종목코드 : O (리얼티 인컴), 종목코드 : DGRW (WISDOMTREE TRUST US QUALITY DIV GRWTH FUND) 등 월배당 기업이나 ETF에 투자하는 월배당 투자. 종목코드 : PG (프록터 앤드 갬블), 종목코드 : SCHD (SCHWAB DIVIDEND EQUITY ETF)\n처럼 배당을 꾸준히 늘려오는 배당 성장 투자. 종목코드 : MO (알트리아), 종목코드 : JEPI (JPMORGAN EQUITY PREMIUM INCOME ETF)와 같은 고배당 투자가 가능합니다.",
    topicTitleSecond: "배당 투자 시 주의할 점은?",
    secondTopicDescription: "배당금 수령은 장점이 될 수 있지만 당 장 눈앞의 배당금만 쫓을 경우 주식거래의 목표인 시세 차익을 놓칠 수 있습니다. 기업이 돈을 벌어들이면 신규 투자를 하여 또 다른 수익원을 창출하여야 하는데 배당금으로 많은 액수를 지불하면 신규 투자 기회를 놓치기 때문입니다.",
    topicTitleThird: "이상적인 배당투자는?",
    thirdTopicDescriptionFirst: "배당의 원천은 기업의 이익입니다. 따라서 장기간 기업이 성장하면서 배당금 지급 규모도 늘리는 기업을 발굴하는 것이 중요한데요.\n예를 들어 많은 투자자들로부터 사랑받는 배당 성장 ETF 중 하나인\n종목코드 : SCHD (SCHWAB DIVIDEND EQUITY ETF)\n의 경우 2012년에 1,000만 원을 투자해서 10년간 보유를 했다면 주가, 배당금 규모 모두 각각 3배씩 올라서 평가금액은 약 3,000만 원, 96만 원에 달하는 배당금은 덤으로 가져가고 있을 것입니다.",
    thirdTopicDescriptionSecond: "이처럼 나만의 성공적인 포트폴리오를 만들어 파이어족을 꿈꿔보세요!",
    warningText: "※주의 : 위에서 언급한 종목들은 추천 종목이 아닙니다."
};
var EbestDividendInvestingGuide = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "mainTitle",
                children: strings.mainTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "introduction first",
                children: strings.introductionFirst
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "company-images",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_image/* default */.Z, {
                    src: "/images/ebest/dividend-company-images.png",
                    alt: "dividend company images",
                    layout: "responsive",
                    width: 327,
                    height: 758
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "introduction second",
                children: strings.introductionSecond
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-title first",
                children: strings.topicTitleFirst
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-description first",
                children: strings.firstTopicDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-title second",
                children: strings.topicTitleSecond
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-description second",
                children: strings.secondTopicDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-title third",
                children: strings.topicTitleThird
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-description third",
                children: strings.thirdTopicDescriptionFirst
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "table-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_image/* default */.Z, {
                    src: "/images/ebest/chart-image.png",
                    alt: "chart image",
                    layout: "responsive",
                    width: 327,
                    height: 161
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "topic-description third",
                children: strings.thirdTopicDescriptionSecond
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "warning",
                children: strings.warningText
            })
        ]
    });
};
/* harmony default export */ var ebest_dividend_investing_guide = (EbestDividendInvestingGuide);


/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_pages_ebest_ebest_dividend_investing_guide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70312);
/* harmony import */ var _components_pages_ebest_ebest_components_ebest_webview_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94161);




var DividendInvestingGuidePage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_ebest_ebest_components_ebest_webview_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_ebest_ebest_dividend_investing_guide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DividendInvestingGuidePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [521,254,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);